import React from "react";
import styles from "./PlanningForms.module.css";
import { BoxTabs } from "../../../../components/AntdTab/AntdTab";
import MyTemplates from "../MyTemplates/MyTemplates";
import BestDayEverPlanningForm from "./BestDayEverPlanningForm/BestDayEverPlanningForm";

const PlanningForms = () => {
  const items = [
    {
      key: "1",
      label: "BDE Planning Form",
      headerTitle: "Events",
      children: <BestDayEverPlanningForm />,
    },
    {
      key: "2",
      label: " My Planning Form",
      headerTitle: "Events",
      children: <MyTemplates />,
    },
  ];

  return (
    <div>
      <BoxTabs items={items} changeHeaderOnTab={true} />
    </div>
  );
};

export default PlanningForms;
